import React from "react";
import { Link } from "react-router-dom";
import ThreePillars from "../components/threepillars.jsx";
import "./Home.css";

import heroImg from '../images/bb_banner.png'; 
//import extra from '../images/bb_extra.jpg';

import discover from '../images/discoverourstory.png';
import getintouch from '../images/getintouch.png';
import schoolinaction from '../images/schoolinaction.png';

export default function Home() {
  return (
    <div className="home-container">
      {/* Header Banner */}
      <header className="header-banner" style={{
        backgroundImage: `url(${heroImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}>
        <div className="header-content">
          <h1>Bright Beginning Elementary School</h1>
          <p>A nonprofit school that hopes to fight poverty, discrimination and social inequality through education.</p>
          
          <Link to="/about" className="cta-button" onClick={() => { window.scrollTo(0, 0);}}>
            Learn More About Us
          </Link>
        </div>
      </header>

      {/* 3 Pillars Section */}
      <section className="home-pillars">
        <ThreePillars />
      </section>

      {/* Post Graduation / Goals */}
      {/* <section className="post-graduation">
        <div className="post-graduation-content">
          <h2>Where Our Students Go</h2>
          <p>
            Bright Beginning graduates have gone on to excel in esteemed high schools and
            community leadership. Our mission is to equip students with the tools they need to build a
            brighter future.
          </p>
          <img
            src={extra}
            alt="Graduation Success"
          />
        </div>
      </section> */}

      {/* Learn More Banner */}
      <section className="learn-more-banner">
        {/* <h2>Discover Our Story</h2>
        <p>Learn more about our vision, classroom environment, and enrichment programs.</p> */}
        <img src = {discover} className="shrink-image" alt = "Discover Our Story"></img>
        <div>
          <Link to="/about" className="banner-button" onClick={() => { window.scrollTo(0, 0);}}>
            Learn More
          </Link>
        </div>
        
      </section>

      {/* Gallery Link Banner */}
      <section className="gallery-banner">
        {/* <h2>See Our School in Action</h2>
        <p>Explore our gallery to see the children learning, playing, and growing every day.</p> */}
        <img src = {schoolinaction} className="shrink-image" alt = "See Our School in Action"></img>
        <div>
          <Link to="/gallery" className="banner-button" onClick={() => { window.scrollTo(0, 0);}}>
            Explore Gallery
          </Link>
        </div>
        
      </section>

      {/* Contact Banner */}
      <section className="contact-banner">
        {/* <h2>Get in Touch</h2>
        <p>We’d love to hear from you. Contact us to learn more or support our school.</p> */}
        <img src = {getintouch} className="shrink-image" alt = "Get in Touch"></img>
        <div>
          <Link to="/contact" className="banner-button" onClick={() => { window.scrollTo(0, 0);}}>
            Contact Us
          </Link>
        </div>
        
      </section>
    </div>
  );
}
